import { render } from "./WButton.vue?vue&type=template&id=58cac8e0"
import script from "./WButton.vue?vue&type=script&lang=js"
export * from "./WButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__